import { FC, useMemo } from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { AccountModesEnum } from '@/api/amlbotAPI';
import { useAppSelector } from '@/redux/hooks';
import { profileSelectors } from '@/redux/selectors';

import amlbotLogo from '@/assets/images/logo-amlbot.svg';

import styles from './BrandLogo.module.sass';

interface BrandLogoProps {
  className?: string;
}

const BrandLogo: FC<BrandLogoProps> = ({ className }) => {
  const { data: profileData } = useAppSelector(
    profileSelectors.getProfileSlice,
  );

  const modeTag = useMemo(() => {
    switch (profileData?.accountMode) {
      case AccountModesEnum.LITE:
        return 'Personal';
      case AccountModesEnum.PRO:
        return 'Pro';
      case AccountModesEnum.PRO_PLUS:
        return 'Business';
      default:
        return '';
    }
  }, [profileData?.accountMode]);

  return (
    <Link to="/" className={cx(styles.logo, className)}>
      <img src={amlbotLogo} alt="AMLBot" />
      {modeTag && <span className={styles.mode}>{modeTag}</span>}
    </Link>
  );
};

export default BrandLogo;
